module.exports = __webpack_public_path__ + "73a5a6acb4de6f50e513922cdae8da40.MP3";